const link = process.env.REACT_APP_SERVER_API_V2;

const getTrialUrl = () => `${link}/user/trial`;

export default getTrialUrl;
